import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.5 4.25a.75.75 0 01.75.75v12.227l2.227-2.163a.75.75 0 111.045 1.076l-3.5 3.398a.75.75 0 01-1.045 0l-3.5-3.398a.75.75 0 111.045-1.076l2.228 2.162V5a.75.75 0 01.75-.75zM15.977 4.462a.75.75 0 011.045 0l3.5 3.398a.75.75 0 01-1.045 1.076L17.25 6.774V19a.75.75 0 01-1.5 0V6.774l-2.228 2.162a.75.75 0 01-1.045-1.076l3.5-3.398z",
      "clip-rule": "evenodd"
    })
  ]))
}